import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectOption } from '../models';

@Pipe({
    name: 'addClearOption',
    standalone: true
})
export class AddClearOptionPipe<T, E> implements PipeTransform {
    constructor(private _i18n: TranslateService) {}
    transform(options: SelectOption<T, E>[] = [], addClear: boolean): SelectOption<T, E>[] {
        let optionsReturn: SelectOption<T, E>[] = [];

        if (addClear) {
            optionsReturn.push({
                label: this._i18n.instant('UTILS.SELECT.CLEAR_CHOICE'),
                value: '' as E
            });
        }

        if (Array.isArray(options)) {
            optionsReturn = optionsReturn.concat(options);
        }

        return optionsReturn;
    }
}
